import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { useTranslation } from "react-i18next";

interface ConfirmationModalProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  open,
  title,
  message,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  isLoading = false,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="confirmation-dialog-title"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="confirmation-dialog-title" sx={{ pb: 2, px: 3 }}>
        <Typography variant="h5">{title}</Typography>
      </DialogTitle>
      <DialogContent sx={{ px: 3 }}>
        <Box sx={{ mb: 3 }}>
          <Typography>{message}</Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 3, pt: 2 }}>
        <Button
          onClick={onCancel}
          disabled={isLoading}
          sx={{ color: (theme) => theme.palette.neutral[600] }}
        >
          {cancelLabel || t("common.cancel")}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          disabled={isLoading}
          sx={{ color: "white" }}
        >
          {confirmLabel || t("common.delete")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
